<template>
    <div class="app-academy">
        <div class="card p-0 mb-4">
          <div class="card-body d-flex flex-column flex-md-row justify-content-between p-0 pt-4">
            <div class="app-academy-md-25 card-body ">
              <img
                src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/bulb-light.png"
                class="img-fluid app-academy-img-height scaleX-n1-rtl"
                alt="Bulb in hand"
                data-app-light-img="illustrations/bulb-light.png"
                data-app-dark-img="illustrations/bulb-dark.png"
                height="90" />
            </div>
            <div class="app-academy-md-50 card-body d-flex align-items-md-center flex-column text-md-center">
              <h3 class="card-title mb-4 lh-sm px-md-5 lh-lg">
                Credit Education & Financial Literacy<br>
                <span class="text-primary fw-medium text-nowrap">All in one place</span>.
              </h3>
              <p class="mb-3">
                Grow your credit knowledge with the most reliable online courses.
              </p>
              <div class="d-flex align-items-center justify-content-between app-academy-md-80">
                <input type="search" placeholder="Find your course" class="form-control mr-1" v-model="searchitem" @keyup="debouncedSearchData"/>
                <button type="submit" class="btn btn-primary btn-icon"><vue-feather type="search" size="12"></vue-feather></button>
              </div>
            </div>
            <div class="app-academy-md-25 d-flex align-items-end justify-content-end">
              <img
                src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/pencil-rocket.png"
                alt="pencil rocket"
                height="188"
                class="scaleX-n1-rtl" />
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { ref, reactive, computed, toRefs } from 'vue'
export default {
    props: {
        route:{
            type: String,
        },
        method: {
            type: Function,
        },
        pagination: {
            type: Boolean
        },
        query:{
            type:String
        }
    },
    setup(props) {
        const state = reactive({
            result: {},
            limit:10,
            searchitem: ref(null),
        }),
        url = computed(() => {
            return props.route
        }),
        searchResults = computed(() => {
            return props.method
        }),
        pagination = computed(() => {
            return props.pagination
        }),
        query = computed(() => {
            return props.query
        });
        return {
            searchResults,
            pagination,
            url,
            query,
            ...toRefs(state),
        }
    },
    computed: {
        debouncedSearchData() {
            return _.debounce(this.searchCartegory, 1000);
        },
    },
    methods: {
        searchCartegory(e) {
            if (!_.isNull(this.searchitem)) {
                var payload = {
                    searchTerm: this.searchitem
                }
                let route;
                route = this.$router.resolve({
                    name:this.url,
                    query: {
                        page:'1',
                        limit:this.limit
                    }
                });
                if(!_.isNull(this.query)){
                    route = this.$router.resolve({
                        name:this.url,
                        query: {
                            type: this.query,
                            page:'1',
                            limit:this.limit
                        }
                    });
                }

                axios.post(`${route.href}`, payload).then(({ data }) => {
                    return this.searchResults(data, true);
                }).catch((error) => {
                    toastr.error(error, 'Error!');
                })
            }else{
                let data = [{}]
                return this.searchResults(data, true);
            }


        }
    },
}
 </script>
